import { actions } from '@adc/ui-morpheus'
import { fetchTransactionsSeek } from '../providers/transactions'
import { TRANSACTIONS } from '../constants/tableTypes'

export const {
  fetchTable,
  fetchTableAppend,
  fetchTableBatches,
  addFilter,
  clearFilters,
  changeSortBy,
  removeFilter,
} = actions.dataTable.initDataTable(TRANSACTIONS, {
  getTableValues: fetchTransactionsSeek,
})

export const { abortTableValues, resetTableValues } = actions.dataTable
